/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { BlankEnum } from './blankEnum';
import { GenderEnum } from './genderEnum';
import { NullEnum } from './nullEnum';
import { OverviewAttendance } from './overviewAttendance';

export interface ChildAttendanceOverview { 
    childUuid: string;
    firstName: string;
    lastName: string;
    gender?: GenderEnum | BlankEnum | NullEnum;
    profileImage?: string;
    thumbnail?: string;
    readonly archived: boolean;
    readonly attendance: Array<OverviewAttendance>;
}